module.exports = __webpack_public_path__ + "img/sedziwy.7f9b7112.jpg";